var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrownJarOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 77,
    viewBox: "0 0 32 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8H10V9H9.5C9.22386 9 9 9.22386 9 9.5C9 9.77614 9.22386 10 9.5 10H10V11H9.5C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12H10V13H9.5C9.22386 13 9 13.2239 9 13.5C9 13.7761 9.22386 14 9.5 14H10V15H9C8.44771 15 8 15.4477 8 16C8 16.5523 8.44771 17 9 17H10V19C10 19 0 27.3636 0 35.7273C0 35.8192 0.00386518 35.9101 0.0115106 36H0V70C0 73.866 3.13401 77 7 77H25C28.866 77 32 73.866 32 70V36H31.9885C31.9961 35.9101 32 35.8192 32 35.7273C32 27.3636 22 19 22 19V17H23C23.5523 17 24 16.5523 24 16C24 15.4477 23.5523 15 23 15H22V14H22.5C22.7761 14 23 13.7761 23 13.5C23 13.2239 22.7761 13 22.5 13H22V12H22.5C22.7761 12 23 11.7761 23 11.5C23 11.2239 22.7761 11 22.5 11H22V10H22.5C22.7761 10 23 9.77614 23 9.5C23 9.22386 22.7761 9 22.5 9H22V8Z",
    fill: "#462316"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 35H9V74.9861C9 74.9861 2 75.4859 2 70.4877C2 65.4894 2 35 2 35Z",
    fill: "#6D4334"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 35C2 30.6 7.66667 23.1666 11 20H13C13 20 8.83333 30.6666 9 35C5.66667 36.8333 2 39.4 2 35Z",
    fill: "#6D4334"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 41C0 41 0 42 16 42C32 42 32 41 32 41V61C32 61 32 62 16 62C0 62 0 61 0 61V41Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownJarOpen);
export default __webpack_public_path__ + "static/media/brown_jar_open.a2ffb964bf2768f18eb1e4227bc8828e.svg";
export { ForwardRef as ReactComponent };